import { defineStore } from 'pinia';
import { jwtDecode, type JwtPayload } from 'jwt-decode';

export interface State {
  ready: boolean;
  type?: 'user' | 'grant';
  accessToken?: () => Promise<string> | string;
  subject: string | undefined;
  scopes: string[];
}

export const useAuthStore = defineStore('auth', {
  state: (): State => ({
    ready: false,
    type: undefined,
    accessToken: undefined,
    subject: undefined,
    scopes: [],
  }),

  getters: {
    isAuthenticated: (state): boolean => state.ready && state.type !== undefined,
    isAuthenticatedAs: (state) => (type: State['type']) => state.ready && state.type === type,
  },

  actions: {
    update(type: State['type'], accessToken?: State['accessToken']) {
      this.type = type;

      if (accessToken) {
        this.accessToken = async () => {
          const token = await accessToken();

          try {
            const payload = jwtDecode<JwtPayload & { scopes?: string[] }>(token);

            this.subject = payload.sub;
            this.scopes = payload.scopes || [];
          } catch (error) {
            this.subject = undefined;
            this.scopes = [];
            throw error;
          }

          return token;
        };
      } else {
        this.accessToken = undefined;
        this.subject = undefined;
        this.scopes = [];
      }

      this.ready = true;
    },
  },
});
